"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _userenderscount = _interopRequireDefault(require("@hedtech/userenderscount"));
var _toolkit = require("@reduxjs/toolkit");
var _lodash = require("lodash");
var _reactRedux = require("react-redux");
var _formSlice = require("../redux/slices/formSlice");
var _core = require("@ellucian/react-design-system/core");
var _excluded = ["name", "onBlur", "onFocus", "value"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var FormSwitch = function FormSwitch(props) {
  var name = props.name,
    onBlurProp = props.onBlur,
    onFocusProp = props.onFocus,
    value = props.value,
    rest = _objectWithoutProperties(props, _excluded);
  (0, _userenderscount["default"])("FormSwitch ( ".concat(name, " ) ").concat(value));
  var selectValueChecked = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.values, (0, _lodash.toPath)(name));
    }, function (value) {
      return !!value;
    });
  }, [name]);
  var checked = (0, _reactRedux.useSelector)(selectValueChecked);
  var dispatch = (0, _reactRedux.useDispatch)();
  var onChange = (0, _react.useCallback)(function (e) {
    var newValue;
    if (!e.target.value) {
      newValue = e.target.checked;
    } else {
      newValue = e.target.checked ? e.target.value : undefined;
    }
    dispatch((0, _formSlice.setValue)({
      name: name,
      value: newValue
    }));
  }, [dispatch, name]);
  var onBlur = (0, _react.useCallback)(function (e) {
    (0, _reactRedux.batch)(function () {
      dispatch((0, _formSlice.setTouched)({
        name: e.target.name,
        value: true
      }));
      dispatch((0, _formSlice.setFocused)({
        name: e.target.name,
        value: false
      }));
    });
    onBlurProp && onBlurProp(e);
  }, [dispatch, onBlurProp]);
  var onFocus = (0, _react.useCallback)(function (e) {
    dispatch((0, _formSlice.setFocused)({
      name: e.target.name,
      value: true
    }));
    onFocusProp && onFocusProp(e);
  }, [dispatch, onFocusProp]);
  var inputProps = (0, _react.useMemo)(function () {
    return {
      onBlur: onBlur,
      onFocus: onFocus
    };
  }, [onBlur, onFocus]);
  return /*#__PURE__*/_react["default"].createElement(_core.Switch, _extends({}, rest, {
    name: name,
    inputProps: inputProps,
    onChange: onChange,
    checked: checked,
    value: value
  }));
};
FormSwitch.propTypes = {
  name: _propTypes["default"].string.isRequired,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  value: _propTypes["default"].string
};
var _default = exports["default"] = FormSwitch;